import { Routes, Route } from "react-router-dom";
import { useAuth } from "./auth/useAuth";
import Login from "./pages/Login";
import Chat from "./pages/Chat";
import SharedView from "./pages/SharedView";
import { Loader2, ShieldAlert } from "lucide-react";
import { performLogout } from "./api/client";

/** 미등록 사용자(403 CHAT_NOT_REGISTERED) 안내 — 관리자 등록 요청 + 다른 계정 로그인. */
function AccessDenied({ message }: { message: string }) {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-4 px-6 text-center">
      <ShieldAlert className="h-12 w-12 text-amber-500" />
      <div>
        <h1 className="text-lg font-bold">웹채팅 사용 등록이 필요합니다</h1>
        <p className="mt-2 max-w-sm text-sm text-muted-foreground">{message}</p>
        <p className="mt-1 max-w-sm text-xs text-muted-foreground">
          관리자가 운영 포털의 <b>사용자 관리</b>에서 등록하면 바로 이용할 수 있습니다.
        </p>
      </div>
      <button
        onClick={() => performLogout()}
        className="w-full max-w-xs rounded-lg border border-border px-4 py-2.5 text-sm font-semibold hover:bg-accent"
      >
        다른 계정으로 로그인
      </button>
    </div>
  );
}

function Gate() {
  const { loading, authenticated, denied } = useAuth();
  if (loading) {
    return (
      <div className="flex h-full items-center justify-center text-muted-foreground">
        <Loader2 className="mr-2 h-5 w-5 animate-spin" /> 불러오는 중…
      </div>
    );
  }
  if (denied) return <AccessDenied message={denied.message} />;
  return authenticated ? <Chat /> : <Login />;
}

export default function App() {
  return (
    <Routes>
      {/* 공개 읽기전용 공유 — 로그인 불필요 */}
      <Route path="/s/:token" element={<SharedView />} />
      <Route path="*" element={<Gate />} />
    </Routes>
  );
}
